import axios from "@/api/axiosInstance";

//MEMBERS
export function addMember(payload) {
  return axios.post(`/api/v1/members/${payload.id}`, payload.values);
}

export function fetchMembers(payload) {
  return axios.get(`/api/v1/members/${payload.id}?page=${payload.pageNumber}`);
}

export function updateMember(payload) {
  return axios.patch(`/api/v1/members/actions/${payload.id}`, payload.values);
}

export function deleteMember(payload) {
  return axios.delete(`/api/v1/members/actions/${payload}`);
}
